import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import styles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import editIcons from "../../../assets/images/edit-icon.png";
import LoadingButton from "../../../components/LoadingButton";
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";
import BuyerOrgHeader from "../../BuyerOrgHeader";
import { getOrganisationList, handleUserStatus } from "../../../actions/organisation";
import { openSnackBar } from "../../../actions/snack-bar";
import AddOrganisationModal from "../../../components/Organisation/AddOrganisationModal";
import { CircularProgress } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

class OrgDashboard extends React.Component {
  state = {
    organisationList: [],
    pageSize: 10,
    pageNumber: 1,
    keyword: "",
    count: 0,
    loading: false,
    openBar: false
  };

  handleChangePage = (event, newPage) => {
    this.setState({ pageNumber: newPage + 1 }, () => {
      this.getList();
    });
  };

  componentDidMount() {
    this.getList();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.refreshList && !this.props.refreshList) {
      this.getList();
    }
  }

  getList = () => {
    this.setState({ loading: true });
    const { pageNumber, pageSize, keyword } = this.state;
    this.props
      .dispatch(getOrganisationList(pageNumber, pageSize, keyword))
      .then(response => {
        this.setState({ organisationList: response.data, count: response.count, loading: false });
      })
      .catch(err => {
        this.setState({ loading: false });
        const message = err && err.message;
        this.props.dispatch(
          openSnackBar({
            message
          })
        );
      });
  };

  addOrgnisation = organisation => {
    const orgData = organisation && JSON.parse(JSON.stringify(organisation));
    if (orgData && orgData.phone) {
      orgData.phone = orgData.phone.replace('+1', '');
    }
    this.props.dispatch({ type: "ADD_ORGANISATION", payload: true, data: orgData });
  };

  handleUser = (event, orgId, status) => {
    this.setState({ loading: true });
    status = status === "active" ? "deactive" : "active";
    event.preventDefault();
    this.props
      .dispatch(handleUserStatus(orgId, status, true))
      .then(response => {
        this.closeOpenBar();
        this.getList();
        this.props.dispatch(
          openSnackBar({
            message: response.message
          })
        );
      })
      .catch(err => {
        this.setState({ loading: false });
        const message = err && err.message;
        this.props.dispatch(
          openSnackBar({
            message
          })
        );
      });
  };

  setOpenBar = (orgId, status) => {
    if (status) {
      this.closeOpenBar();
      return;
    }
    this.closeOpenBar()
    const { organisationList } = this.state;
    const foundIndex = organisationList.findIndex(x => x.id === orgId);
    organisationList[foundIndex].openBar = true;
    this.setState({ organisationList });
  }

  closeOpenBar = () => {
    const { organisationList } = this.state;
    organisationList.map(r => { r.openBar = false });
    this.setState({ organisationList });
  }

  render() {
    const { classes, editOrganisationData } = this.props;
    return (
      <div>
        <BuyerOrgHeader authentication={this.props.authentication} />
        <div className={classes.pageLoader}>
          {this.state.loading && <CircularProgress size={60} />}
        </div>
        <div className={classes.container}>
          <div className={classes.innerWrap}>
            <div className={classes.headingWrap}>
              <Typography variant="h2" className={classes.headingWrapheading}>
                Manage Organization {!this.state.loading && `(${this.state.count})`}
              </Typography>

              <div className={classes.headingButtonWrap}>
                <LoadingButton
                  variant="contained"
                  className={classes.largeButton}
                  onClick={() => this.addOrgnisation(null)}
                >
                  Add Organization
                </LoadingButton>
              </div>
            </div>
            <div className={classes.dashboardTable}>

              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Organization Name</TableCell>
                    <TableCell>Owner Name</TableCell>
                    <TableCell>Email Id</TableCell>
                    <TableCell>Mobile No.</TableCell>
                    <TableCell>Account Status</TableCell>
                    <TableCell className={classes.tableCenter}>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    this.state.organisationList.map(item => {
                      return (<TableRow key={item.id}>
                        <TableCell>{item.org_name}</TableCell>
                        <TableCell>{item.owner_name}</TableCell>
                        <TableCell>{item.email}</TableCell>
                        <TableCell>{item.phone}</TableCell>
                        <TableCell>
                          <div className={classes.accountStatusDropdown}>
                            {item.status === 'active' ? <span className={classes.textSuccess}>Active</span> :
                              <span className={classes.textDanger}>Deactive</span>}
                            <IconButton
                              aria-label="account of current user"
                              aria-controls="menu-appbar"
                              aria-haspopup="true"
                              onClick={this.handleMenu}
                              color="inherit"
                            >
                              <ExpandMoreIcon onClick={() => this.setOpenBar(item.id, item.openBar)} />
                            </IconButton>
                            {item.openBar && <div className={classes.StatusDropdown}>
                              {item.status === 'deactive' ? <Link to="#"
                                onClick={e =>
                                  this.handleUser(e, item.id, item.status)
                                }
                                className={classes.textSuccess}>
                                Active
                              </Link> :

                                <Link to="#"
                                  onClick={e =>
                                    this.handleUser(e, item.id, item.status)
                                  }
                                  className={classes.textDanger}>
                                  Deactive
                              </Link>}
                            </div>}
                          </div>
                        </TableCell>
                        <TableCell className={classes.tableCenter}>
                          <Typography>
                            <Link to="#" onClick={() => this.addOrgnisation(item)}>
                              <img
                                src={editIcons}
                                alt="Edit Icon"
                              />
                            </Link>
                          </Typography>
                        </TableCell>
                      </TableRow>)
                    })
                  }
                </TableBody>
              </Table>
              {!this.state.loading && !this.state.organisationList.length &&
                <Typography variant="h2" className={classes.noResultFound}>
                  No Result Found
              </Typography>}
            </div>

            {!this.state.loading && <TablePagination
              className={classes.paginationSection}
              component="div"
              count={this.state.count}
              rowsPerPageOptions={[]}
              rowsPerPage={10}
              page={this.state.pageNumber - 1}
              onChangePage={this.handleChangePage}
              backIconButtonProps={{
                "aria-label": "previous page"
              }}
              nextIconButtonProps={{
                "aria-label": "next page"
              }}
            />}
          </div>
          <div className={classes.copyright}>
            @2019 SafeShowings. All Right <span>Reserved</span>
          </div>
        </div>
        {this.props.addOrganisationModal && (
          <AddOrganisationModal open={this.props.addOrganisationModal} editOrganisationData={editOrganisationData} />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    addOrganisationModal: state.modalHandler.addOrganisationModal,
    editOrganisationData: state.modalHandler.editOrganisationData,
    refreshList: state.modalHandler.refreshList
  };
};
const mapActionsToProps = dispatch => {
  return {
    dispatch
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapActionsToProps
  ),
  withStyles(styles)
)(OrgDashboard);
